import request from "@/utils/request";

export function tableHeaderConfigurationGetAll(params) {
    return request({
        url: "/api/services/app/TableHeaderConfiguration/GetAll",
        method: "get",
        params
    });
}

export function tableHeaderConfigurationGetHeaders(params) {
    return request({
        url: "/api/services/app/TableHeaderConfiguration/GetHeaders",
        method: "get",
        params
    });
}

export function tableHeaderConfigurationGet(params) {
    return request({
        url: "/api/services/app/TableHeaderConfiguration/Get",
        method: "get",
        params
    });
}

export function tableHeaderConfigurationStoreHeaders(data) {
    return request({
        url: "/api/services/app/TableHeaderConfiguration/StoreHeaders",
        method: "post",
        data
    });
}

export function tableHeaderConfigurationUpdate(data) {
    return request({
        url: "/api/services/app/TableHeaderConfiguration/Update",
        method: "put",
        data
    });
}

export function tableHeaderConfigurationDelete(params) {
    return request({
        url: "/api/services/app/TableHeaderConfiguration/Delete",
        method: "delete",
        params
    });
}


// WEBPACK FOOTER //
// ./src/api/table_header_configuration.js